import { render } from "./DocumentFilter.vue?vue&type=template&id=82b45bfa"
import script from "./DocumentFilter.vue?vue&type=script&lang=js"
export * from "./DocumentFilter.vue?vue&type=script&lang=js"

import "./DocumentFilter.vue?vue&type=style&index=0&id=82b45bfa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__